import { NavRoute } from '../shared/navigation/nav.route.interface';
import { getAdminNav } from './nav-areas/admin-nav';

export const getMainNavRoutes: () => NavRoute[] = function () {
	return [
		getAdminNav(),
		{
			name: 'Monthly Bill Comparison List',
			security: sec => sec.coreFeatures,
			exact: true,
			path: 'pcg-forms/bill-comparisons-list',
		},
		{
			name: 'Reports',
			security: sec => sec.adminFeatures,
			children: [
				{
					name: 'Monthly Bill Comparison Report',
					security: sec => sec.adminFeatures,
					exact: true,
					path: 'reports/monthly-bill-comparison'
				},
				{
					name: 'Financial Report',
					security: sec => sec.manageUsers,
					exact: true,
					path: 'reports/financial',
				},
			]
		}
	];
};
